import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热门内容精选</h2>
          <p className="text-sm md:text-base text-foreground-400">精选最新最热的国产吃瓜视频内容，热门娱乐资讯一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden group cursor-pointer hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-bold bg-primary-500 text-background-50 rounded-md">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4 line-clamp-2">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {card.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}